import { FC, useContext, useState } from 'react'
import cx from 'classnames'

import { TeamsFxContext } from '../Context'

import './DisplayTab.css'
import { ApplicationFrame } from '../ApplicationFrame/ApplicationFrame'
import { ConfigurableTabAuth } from './ConfigurableTabAuth'

export const DisplayTab: FC<object> = () => {
  const [domain, setDomain] = useState<string | null>(localStorage.getItem('domain'))
  const [authToken, setAuthToken] = useState<string | null>(localStorage.getItem('auth_token'))
  const { themeString, teamsUserCredential } = useContext(TeamsFxContext)
  

  const handleLogout = (): void => {
    setAuthToken(null)
    localStorage.removeItem('auth_token')
    localStorage.removeItem('initialLocation')
  }

  const handleLoginSuccess = (domain: string | null, nextAuthToken: string | null): void => {
    setDomain(domain)
    setAuthToken(nextAuthToken)

    if (domain !== null) {
      localStorage.setItem('domain', domain)
    } else {
      localStorage.removeItem('domain')
    }

    if (nextAuthToken !== null) {
      localStorage.setItem('auth_token', nextAuthToken)
    } else {
      localStorage.removeItem('auth_token')
    }
  }

  return (
    <div
      id='display-tab'
      className={cx({
        light: themeString === 'default',
        dark: themeString === 'dark',
        contrast: themeString !== 'default' && themeString !== 'dark'
      })}
    >
      {authToken !== null && domain !== null
        ? <ApplicationFrame domain={domain} timesheet={false} onLogout={handleLogout} />
        : <ConfigurableTabAuth defaultDomain={domain} authToken={authToken} onLoginSuccess={handleLoginSuccess} 
        reLogin={true} teamsUserCredential={teamsUserCredential}/>}
    </div>
  )
}
